function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M64.904 0l64.904 37.5v75L64.904 150 0 112.5v-75L64.904 0z",
  fill: "#CDDEFF"
});

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "avatar-request-translation_svg__a",
  maskUnits: "userSpaceOnUse",
  x: 7,
  y: 9,
  width: 115,
  height: 132
}, /*#__PURE__*/React.createElement("path", {
  d: "M64.853 9.027l57.046 32.96v65.92l-57.046 32.96-57.046-32.96v-65.92l57.046-32.96z",
  fill: "#fff"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#avatar-request-translation_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M64.853 9.027l57.046 32.96v65.92l-57.046 32.96-57.046-32.96v-65.92l57.046-32.96z",
  fill: "url(#avatar-request-translation_svg__paint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.959 112.244H14.77v34.063h105.189v-34.063z",
  fill: "#9013FE"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47.253 6.873L35.89 70.997h57.823L82.345 6.874H47.252z",
  fill: "#fff",
  fillOpacity: 0.179
}));

var _ref4 = /*#__PURE__*/React.createElement("mask", {
  id: "avatar-request-translation_svg__b",
  maskUnits: "userSpaceOnUse",
  x: 7,
  y: 9,
  width: 115,
  height: 132
}, /*#__PURE__*/React.createElement("path", {
  d: "M64.853 9.027l57.046 32.96v65.92l-57.046 32.96-57.046-32.96v-65.92l57.046-32.96z",
  fill: "#fff"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#avatar-request-translation_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M64.853 9.027l57.046 32.96v65.92l-57.046 32.96-57.046-32.96v-65.92l57.046-32.96z",
  fill: "#0043C5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.628 27.188H15.18v95.725h99.448V27.188z",
  fill: "#fff"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M101.659 49.453H28.354a1.487 1.487 0 000 2.975h73.305a1.487 1.487 0 000-2.975zM101.659 39.809H28.354a1.487 1.487 0 000 2.975h73.305a1.487 1.487 0 000-2.975zM101.659 59.098H28.354a1.487 1.487 0 000 2.975h73.305a1.487 1.487 0 000-2.975zM101.659 68.742H28.354a1.487 1.487 0 000 2.976h73.305a1.487 1.487 0 000-2.976zM101.659 78.387H28.354a1.487 1.487 0 000 2.975h73.305a1.487 1.487 0 000-2.975zM101.659 88.03H28.354a1.487 1.487 0 000 2.975h73.305a1.487 1.487 0 000-2.976zM101.659 97.674H28.354a1.487 1.487 0 000 2.975h73.305a1.487 1.487 0 000-2.975zM101.659 107.318H28.354a1.487 1.487 0 000 2.976h73.305c.821 0 1.486-.666 1.486-1.488s-.665-1.488-1.486-1.488z",
  fill: "#00308D"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.757 49.762h36.294l-17.46 25.29 17.46 25.291H46.757l17.054-25.29-17.054-25.291z",
  fill: "#00308D"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M65.007 66.793c13.136 0 23.785-10.656 23.785-23.803 0-13.146-10.65-23.803-23.785-23.803-13.137 0-23.786 10.657-23.786 23.803 0 13.147 10.65 23.803 23.786 23.803z",
  fill: "#03ABFF"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M78.528 31.642l.173 3.044c-4.19.242-9.349.415-15.477.554-.139 1.176-.208 2.352-.277 3.528 1.488-.311 3.081-.45 4.743-.45.45 0 .9 0 1.385.035l.485-1.833 3.185.726c-.138.554-.311 1.142-.45 1.695 1.212.346 2.32.9 3.359 1.591 2.527 1.73 3.809 4.083 3.809 7.058 0 3.147-1.108 5.57-3.255 7.299-2.008 1.556-5.055 2.629-9.141 3.182l-1.143-2.905c3.324-.416 5.817-1.211 7.48-2.318 1.8-1.28 2.734-3.044 2.734-5.258 0-2.076-1.004-3.702-2.943-4.844-.588-.345-1.211-.588-1.835-.795-1.038 2.975-2.285 5.57-3.705 7.749-3.081 4.6-6.855 6.918-11.357 6.918-1.73 0-3.15-.553-4.19-1.66-1.038-1.107-1.557-2.595-1.557-4.463 0-3.251 1.593-6.088 4.847-8.475a15.883 15.883 0 014.19-2.283c.035-1.488.138-2.975.277-4.463-2.77 0-5.679.035-8.76.035l-.035-3.079c3.255 0 6.302-.034 9.141-.034.173-1.384.416-2.802.693-4.186l3.289.692a37.945 37.945 0 00-.589 3.459c6.06-.138 11.046-.311 14.924-.519zm-10.446 9.706h-.447c-1.72 0-3.302.174-4.781.556v.07c0 2.85.172 5.491.55 7.89.447-.557.894-1.182 1.376-1.843 1.273-1.946 2.374-4.17 3.302-6.673zm-8.523 1.846c-.66.31-1.285.689-1.84 1.102-2.603 1.825-3.888 3.89-3.888 6.197 0 2.031.799 3.064 2.465 3.064 1.458 0 2.88-.413 4.2-1.17-.556-2.79-.868-5.853-.938-9.193z",
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M65.007 131.225c13.136 0 23.785-10.657 23.785-23.803s-10.65-23.803-23.785-23.803c-13.137 0-23.786 10.657-23.786 23.803s10.65 23.803 23.786 23.803z",
  fill: "#03ABFF"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M62.444 90.492h5.085l11.277 29.303h-4.798l-2.747-7.552H58.67l-2.748 7.552h-4.757l11.278-29.303zm-2.42 18.058h9.883l-4.839-13.256h-.164l-4.88 13.256z",
  fill: "#fff"
});

var _ref12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "avatar-request-translation_svg__paint0_linear",
  x1: 64.853,
  y1: 9.027,
  x2: 64.853,
  y2: 140.867,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8400DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D00B4"
})));

function SvgAvatarRequestTranslation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 130 150",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

export default SvgAvatarRequestTranslation;